import React, { forwardRef, ForwardRefRenderFunction, memo } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export interface GenTextFieldProps extends Omit<TextFieldProps, "error"> {
  error?: string;
  accept?: string;
}

const GenTextField: ForwardRefRenderFunction<
  TextFieldProps,
  GenTextFieldProps
> = (props, ref) => {
  const {
    error,
    placeholder,
    helperText,
    className,
    required,
    label,
    ...otherProps
  } = props;

  return (
    <TextField
      inputRef={ref}
      label={
        required ? (
          <Typography color="text.disabled">
            {label || "Required"}
            <Typography component="span" color="error">
              *
            </Typography>
          </Typography>
        ) : label ? (
          <Typography color="text.disabled">{label}</Typography>
        ) : undefined
      }
      error={!!error}
      placeholder={placeholder}
      helperText={
        <Typography
          component="span"
          variant="caption"
          color={error ? "error" : "secondary.light"}
        >
          {error || helperText}
        </Typography>
      }
      margin="none"
      size="medium"
      onKeyDown={(e) => {
        if (e.key === "Backspace" || e.key === "Delete") {
          e.nativeEvent.stopImmediatePropagation();
        }
      }}
      sx={{
        marginTop: 2,
        marginBottom: 1,
      }}
      {...otherProps}
    />
  );
};

export default memo(forwardRef(GenTextField));
